import Kaleidoscope from './Kaleidoscope';
import RGBSplit from './RGBSplit';
import NoisyTrack from './NoisyTrack';
import Smear from './Smear';
import SlitScan from './SlitScan';
import NoiseRecolor from './NoiseRecolor';
import Ripples from './Ripples';
export const canvasEffects = {
  RGBSplit,
  RGBOrb: RGBSplit,
  Kaleidoscope,
  Smear,
  NoisyTrack,
  SlitScan,
  NoiseRecolor,
  Ripples
};
//# sourceMappingURL=index.js.map